import React from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
import 'react-datepicker/dist/react-datepicker.css';

registerLocale('es', es);

interface DatePickerInputProps {
  id?: string;
  value: string;
  onChange: (value: string) => void;
  className?: string;
  disabled?: boolean;
}

const toIsoDate = (date: Date | null): string => {
  if (!date) return '';
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const parseIsoDate = (value: string): Date | null => {
  if (!value) return null;
  const [year, month, day] = value.split('-').map(Number);
  if (!year || !month || !day) return null;
  return new Date(year, month - 1, day);
};

const DatePickerInput: React.FC<DatePickerInputProps> = ({ id, value, onChange, className, disabled }) => {
  return (
    <DatePicker
      id={id}
      selected={parseIsoDate(value)}
      onChange={(date: Date | null) => onChange(toIsoDate(date))}
      dateFormat="dd/MM/yyyy"
      locale="es"
      className={className}
      disabled={disabled}
      showYearDropdown
      scrollableYearDropdown
      yearDropdownItemNumber={100}
      showMonthDropdown
      dropdownMode="select"
      placeholderText="dd/mm/aaaa"
      autoComplete="off"
    />
  );
};

export default DatePickerInput;
